import './fonts.css';
import './housecanary.css';
import './icons.css';
export const DesignSystemStyles = () => {
  return null;
};
